var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-home",class:_vm.activeSection},[_c('div',{staticClass:"violet"}),_c('div',{staticClass:"orange"}),_c('div',{staticClass:"blue"}),_c('div',{staticClass:"green"})])
}
var staticRenderFns = []

export { render, staticRenderFns }